import { gql } from '@apollo/client';

export const GET_DASHBOARD_LAYOUT = gql`
  query GetDashboardLayout($id: ID!) {
    layout: getDashboardLayout(id: $id) {
      id
      name
      category
      config {
        rows {
          sections {
            sectionTitle
            sectionSize
            columns {
              columnSize
              cards {
                cardTitle
                charts {
                  query
                  type
                  variables
                  formatData
                  width
                  height
                  legend
                  options
                }
              }
            }
          }
        }
      }
      platform {
        id
        name
      }
      isDefault
      assignedTo {
        id
        firstName
        lastName
      }
    }
  }
`;
